import {Component, OnInit} from '@angular/core';
import {User} from '../../../../models/user';
import {RestApiService} from '../../../../services/api/rest-api.service';
import {Card} from 'primeng/card';
import {TableModule} from 'primeng/table';
import {ActionButtonComponent} from '../../../../components/form/action-buttons/action-button.component';
import {Button} from 'primeng/button';
import {UserFormComponent} from '../user-form/user-form.component';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfirmationService} from 'primeng/api';
import {NgIf} from '@angular/common';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-users-list',
  imports: [
    Card,
    TableModule,
    ActionButtonComponent,
    Button,
    NgIf,
  ],
  templateUrl: './users-list.component.html',
  styleUrl: './users-list.component.scss'
})
export class UsersListComponent implements OnInit {
  loading = false;
  users: User[] = [];

  constructor(private api: RestApiService,
              private confirmationService: ConfirmationService,
              private dialogService: DialogService) {
  }

  ngOnInit(): void {
    this._load(); // no await
  }

  private async _load() {
    try {
      this.loading = true;
      const response = await this.api.users.getAllUsers();
      this.users = response.data;
    } finally {
      this.loading = false;
    }
  }

  obj(item: User) {
    return item;
  }

  addUser() {
    this._editUser(0);
  }

  editUser(user: User) {
    this._editUser(user.userId);
  }

  private _editUser(userId: number) {
    const dialog = UserFormComponent.openDialog(this.dialogService, userId);
    dialog.onClose
      .pipe(untilDestroyed(this))
      .subscribe(async () => {
        await this._load();
      });
  }

  // removeUser(user: User) {
  //   // ask for confirmation
  //   this.confirmationService.confirm({
  //     header: 'Conferma eliminazione',
  //     message: 'Sei sicuro di voler eliminare l\'utente?',
  //     acceptLabel: 'Eliminare l\'utente',
  //     rejectLabel: 'Annulla',
  //     icon: 'pi pi-exclamation-triangle',
  //     acceptIcon: 'pi pi-trash',
  //     acceptButtonStyleClass: 'p-button-danger',
  //
  //     accept: async () => {
  //       try {
  //         await this.api.users.delete(user.userId);
  //         this.users = this.users.filter(u => u.userId !== user.userId);
  //       } catch (e) {
  //         console.error(e);
  //       }
  //     }
  //   });
  // }
}
